// TenantSelector.jsx
import { Select } from "../../../components/ReadonlyAwareInputs";
import { getIdByName, getNamesFromList } from "../util/homeUtil";

const TenantSelector = ({ tenantList, setSelectedTenant, isLoading }) => {
  return (
    <div className="row">
      <p className="col-3 text-vertical-center">Select a tenant:</p>
      <Select
        className="col-5"
        disabled={isLoading || tenantList?.length === 0}
        searchable
        data={getNamesFromList(tenantList)}
        onSelect={(tenantName) => {
          setSelectedTenant(getIdByName(tenantName, tenantList));
        }}
      ></Select>
    </div>
  );
};

export default TenantSelector;
